import { forwardRef } from 'react';
import { RootComponent } from '../../services/root-component';
import { Props } from './types';
import css from './style.module.css';
import { NumberKit } from '@team/number';
import { Assert } from '@team/assert';

export const Entry = forwardRef<HTMLProgressElement, Props>(function Component(
  {
    value = 0,
    max = 100,
    min = 0,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelId,
    ...props
  },
  forwardedRef
) {
  if (import.meta.env.DEV) {
    /**
     * 💬 Комопнент явно должен получать один из aria-атрибутов:
     * – aria-label
     * – aria-labelledby
     *
     * @todo расширить проверку на наличие `<VisualHidden />` в {@link children}
     * @todo декларировать логику в хелпер
     */
    if ([ariaLabel, ariaLabelId].every(Assert.isUndefined)) {
      console.warn(
        '[TelegramUi.Progress]: a11y police. Отсутствует один из пропсов: `aria-label` или `aria-labelledby`'
      );
    }
  }

  return (
    <RootComponent
      {...props}
      Component="div"
      baseClassName={css.root}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={min}
      aria-valuemax={max}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelId}
      ref={forwardedRef}
    >
      <div className={css.track}>
        <div
          className={css.fill}
          style={{ width: `${NumberKit.percentage(value, max)}%` }}
        />
      </div>
    </RootComponent>
  );
});
